/* eslint-disable @khan/frontend/require-stories -- we have stories for the Markdown component */
import {StyleSheet} from "aphrodite";

import SimpleMarkdown from "@khanacademy/simple-markdown";
import {addStyle} from "@khanacademy/wonder-blocks-core";
import * as Perseus from "@khan/component-perseus/perseus";
import {staticUrl} from "@khan/urls";

import type {MarkdownRule} from "../types.ts";

const StyledImg = addStyle("img");
const StyledDiv = addStyle("div");

// Output rule for handling images in the following syntax: ![alt text](URL "optional title")
// Ex. ![Khan Academy Logo](https://www.khanacademy.org/favicon.ico "Khan Academy")
export const imageRule: Readonly<MarkdownRule> = {
    ...SimpleMarkdown.defaultRules.image,
    react: (node, output, state) => {
        return (
            <StyledImg
                alt={node.alt}
                key={state.key}
                src={staticUrl(SimpleMarkdown.sanitizeUrl(node.target) || "")}
                style={styles.image}
                title={node.title}
            />
        );
    },
};

// Output rule for handling the graphie images.
export const graphieRule: Readonly<MarkdownRule> = {
    ...SimpleMarkdown.defaultRules.image,
    order: imageRule.order - 0.5, // put this rule before image
    match: (source, state, prevCapture) => {
        // Check to see if the source resembles an image and if it does,
        // we'll also check whether or not it the image source looks like a
        // graphie URL.
        const capture = imageRule.match(
            source,
            {...state, inline: true},
            prevCapture,
        );
        if (!capture) {
            return null;
        }
        return /web\+graphie:\/\/[^\s]*/.test(capture[2]) ? capture : null;
    },
    parse: (capture, parse, state) => {
        return {
            content: capture[0],
        };
    },
    react: (node, output, state) => {
        return (
            <StyledDiv
                // framework-perseus class is necessary so that the
                // Perseus renderer styles apply correctly.
                className="framework-perseus"
                key={state.key}
                style={styles.graphieBlock}
            >
                <Perseus.Renderer
                    content={node.content}
                    dependencies={Perseus.webappDependenciesV2}
                />
            </StyledDiv>
        );
    },
};

const styles = StyleSheet.create({
    graphieBlock: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    image: {
        marginBlockStart: 0,
        padding: 0,
        maxWidth: "100%",
        height: "auto",
    },
});
